import { c as _c } from "react/compiler-runtime";
import { useMagicLinkRedirect } from '@/hooks/useMagicLinkRedirect';
import Button from '@helios/Button';
import Card from '@helios/Card';
import styles from './ApplicationForm.module.scss';
function StartAdmissionTasks() {
  const $ = _c(7);
  const magicLinkQuery = useMagicLinkRedirect();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h4 className={styles.tasks__title}>You're one step closer!</h4>;
    t1 = <p className={styles.tasks__body}>Log into your portal to complete the steps needed to be considered for admission at Campus.</p>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  const t2 = !magicLinkQuery.isSuccess;
  let t3;
  if ($[2] !== magicLinkQuery.data) {
    t3 = () => {
      window.open(magicLinkQuery.data, "_blank");
    };
    $[2] = magicLinkQuery.data;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = <Card className={styles.tasks} padded="md" surface="subtle">{t0}{t1}<Button disabled={t2} fullWidth={true} arrow={true} onClick={t3}>Start admission tasks</Button></Card>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}
export default StartAdmissionTasks;